import React, { useState } from "react";

import Button from "../Button";
import Box from "../Box";
import Text from "../Text";

import SlackIcon from "./SlackIcon";

function SlackButton({ isDark = true, ...rest }) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <Box display="inline-block" position="relative" mt={3}>
      {showTooltip && (
        <Box
          position="absolute"
          bottom="100%"
          left="50%"
          mb={1}
          style={{ transform: "translateX(-50%)" }}
          zIndex={2}
        >
          <Box
            borderRadius={4}
            px={3}
            py={2}
            width={220}
            style={{
              backgroundColor: "#000",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)"
            }}
          >
            <Text
              color="white"
              fontFamily="roboto"
              fontSize={1}
              textAlign="center"
              lineHeight={1.4}
            >
              Greenlist has shut down and is no longer available.
            </Text>
          </Box>
          <Box
            width={0}
            height={0}
            mx="auto"
            style={{
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderTop: "6px solid #000"
            }}
          />
        </Box>
      )}
      <Box
        style={{ cursor: "pointer" }}
        onClick={() => setShowTooltip(value => !value)}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        {...rest}
      >
        <Button
          accessory={
            <Box mr={2}>
              <SlackIcon fill={isDark ? "#FFF" : "#023A15"} />
            </Box>
          }
          isDark={isDark}
        >
          Connect to Slack
        </Button>
      </Box>
    </Box>
  );
}

export default SlackButton;
